import apiClient from '../apiClient';

export interface SubcategoriesItem {
  name: string;
  href: string;
  imageSrc: string;
  imageAlt: string;
}

export interface Category {
  name: string;
  open: boolean;
  subcategories: SubcategoriesItem[];
}

export interface Brand {
  name: string;
  href: string;
}

export interface Shape {
  name: string;
  href: string;
}

export interface NavData {
  categories: Category[];
  brands: Brand[];
  shapes: Shape[];
}


export const getCategories = async (): Promise<NavData> => {
  const response = await apiClient.get<{ categories: Category[], brands: Brand[], shapes: Shape[] }>('/api/nav/');
  return response.data; // Esto contiene categories, brands y shapes
};